import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { MenuIcon, XIcon } from "lucide-react";
import { useBooking } from "../contexts/BookingContext";
import { images, navItems } from "../data/content";
export function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const {
    openBooking
  } = useBooking();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <header className={`sticky top-0 z-50 w-full bg-cream/95 backdrop-blur-sm transition-[border-color,box-shadow] duration-200 ${scrolled ? "border-b border-cream-line shadow-[0_1px_0_rgba(36,39,43,0.05)]" : "border-b border-transparent"}`} data-id="element-133" data-mp="36bl631excrqh">
      <div className="mx-auto flex h-14 max-w-7xl items-center justify-between px-5 md:h-16 md:px-10" data-id="element-134" data-mp="3f9dqgjzi6pkq">
        <Link to="/" aria-label="FlowKus – Schreibakademie Eva-Maria Bast – zur Startseite" className="flex shrink-0 items-center gap-3" data-id="element-135" data-mp="2rlrhd9iybcyb">
          <img src={images.logo} alt="" className="h-12 w-auto shrink-0 mix-blend-multiply md:h-[60px]" data-id="element-136" data-mp="2mnpzut16bloy" />
          <span className="flex flex-col leading-none text-caramel" aria-hidden="true" data-id="element-137" data-mp="2hovizwmro77h">
            <span className="font-serif text-[1.05rem] font-medium tracking-[0.06em] md:text-[1.2rem]" data-id="element-138" data-mp="3faaq1q5wxrqx">FLOWKUS</span>
            <span className="mt-0.5 text-[7px] uppercase leading-[1.25] tracking-[0.14em] md:text-[8px]" data-id="element-139" data-mp="3adke9f155ibb">
              Schreibakademie
              <br data-id="element-140" data-mp="35j6c8trz4cxo" />
              Eva-Maria Bast
            </span>
          </span>
        </Link>

        <nav aria-label="Hauptnavigation" className="hidden items-center gap-9 lg:flex" data-id="element-141" data-mp="30klkliqsf1ku">
          {navItems.map(item => <Link key={item.href} to={`/${item.href}`} className="whitespace-nowrap text-[15px] tracking-wide text-cocoa transition-colors duration-150 hover:text-bark" data-id="element-142" data-mp="3talgis3b94bk">
              {item.label}
            </Link>)}
          <button type="button" onClick={openBooking} className="whitespace-nowrap rounded-full bg-bark px-5 py-2 text-sm tracking-wide text-cream transition-colors duration-150 hover:bg-bark-deep" data-id="element-143" data-mp="1hnru3lmhlcxw">
            Kostenloses Erstgespräch
          </button>
        </nav>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? "Menü schließen" : "Menü öffnen"} className="rounded-full p-2 text-espresso focus:outline-none focus-visible:ring-2 focus-visible:ring-bark lg:hidden" data-id="element-144" data-mp="1cp6qrdbxud58">
          {open ? <XIcon className="h-6 w-6" data-id="element-145" data-mp="2t0uaogol62i2" /> : <MenuIcon className="h-6 w-6" data-id="element-146" data-mp="2y2jkxu3zic53" />}
        </button>
      </div>

      <AnimatePresence data-id="element-147" data-mp="2xznne6w1tph6">
        {open && <motion.nav id="mobile-nav" aria-label="Mobile Navigation" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute inset-x-0 top-full border-t border-cream-line bg-cream px-5 pb-6 pt-2 shadow-lg md:px-10 lg:hidden" data-id="element-148" data-mp="mdv4mjtwvib7">
            {navItems.map(item => <Link key={item.href} to={`/${item.href}`} onClick={() => setOpen(false)} className="block border-b border-cream-line py-4 font-serif text-2xl text-espresso" data-id="element-149" data-mp="106bd405l08ji">
                {item.label}
              </Link>)}
            <button type="button" onClick={() => {
          setOpen(false);
          openBooking();
        }} className="mt-6 block w-full rounded-full bg-bark px-6 py-4 text-center text-sm tracking-wide text-cream" data-id="element-150" data-mp="3gtx3mnyiov9i">
              Kostenloses Erstgespräch
            </button>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}